import React from 'react';
import moment from 'moment';

export const options = {
  columns: [
    { id: 1, name: '', label: '', sortable: false },
    { id: 2, name: 's.no', label: 'S.NO', sortable: false, type: 'number' },
    { id: 3, name: 'name', label: 'NAME', sortable: true, type: 'string' },
    { id: 4, name: 'email', label: 'EMAIL', sortable: false, type: 'string' },
    { id: 5, name: 'contact', label: 'PHONE', sortable: false, type: 'string' },
    {
      id: 6, name: 'roleList', label: 'ROLE', sortable: true, type: 'string'
    },
    {
      id: 7, name: 'tenantList', label: 'ACCOUNT', sortable: false, type: 'string',
      component: (row) =>
        (<div> {row.tenantList && row.tenantList.length ? row.tenantList.map((a, i) => <div key={i}>{a}</div>) : ''}</div>)
    },
    { id: 8, name: 'modifiedOn', label: 'LAST UPDATED ON', sortable: true, type: 'date', component: (row) => moment(row.modifiedOn).format('YYYY-MM-DD') },
  ],
  keyCol: 'aId',
  actions: [
    {
      type: 'edit',
      text: '',
      icon: 'ti ti-pencil color-beki',
      tooltip: 'Edit',
      iconType: 'new'
    },
    {
      type: 'remove',
      text: '',
      icon: 'ti ti-trash color-beki',
      iconType: 'new',
      confirmation: true,
      confirmationMessage: 'Please confirm if you wish to update this record.'
    }
  ],
  recActive: true,
  showSwitch: true,
  status: {
    key: 'isRecActive',
    active: '1',
    activeIcon: 'mdi mdi-checkbox-marked',
    inActiveIcon: 'mdi mdi-close-box',
    // confirmation: true,
    // activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
    // inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
    type: 'isRecActive'
  },
  actionsThead: true,
  sortable: true,
  dateType: true,
  showSearch: true,
  searchable: true,
  searchColumns: [
    { key: 'name' },
    { key: 'email' },
    { key: "tenantList" }
  ],
  defaultSortParams: {
    sortBy: 'date',
    sortOrder: 'asc'
  },
  paging: true,
  defaultPagingParams: {
    pageSize: 25
  }
}

export const formFields = {
  status: {
    key: 'status',
    label: 'User by status:',
    labelLayout: 'col-md-12',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'value',
  }
};

export const userStatusOptions = [
  { id: -1, value: "All" },
  { id: 1, value: 'Active' },
  { id: 0, value: 'InActive' }
];